import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_WHY_CRIO } from '@src/constants/LeadGenerationConstants/index';
import { ICONS } from './iconRegistry';

const Differentiators = ({ content }) => {
  const { stats, features } = content;
  return (
    <section id="different">
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>What Makes This Program Different</h2>
          <p>
            Most courses teach you <em>about</em> LLMs, RAG and agents. Here, you build, evaluate,
            deploy and operate them.
          </p>
        </div>
        <div className={`${styles.tiles} ${styles.t6}`}>
          {stats.map((stat) => (
            <div className={styles.tile} key={stat.l}>
              <div className={styles.n}>{stat.n}</div>
              <div className={styles.l}>{stat.l}</div>
            </div>
          ))}
        </div>
        <div className={styles.cards3} style={{ marginTop: 22 }}>
          {features.map((f) => {
            const Icon = ICONS[f.icon];
            return (
              <div className={styles.feature} key={f.h}>
                <div className={styles.ic}>{Icon && <Icon size={24} aria-hidden="true" />}</div>
                <h4>{f.h}</h4>
                <p>{f.p}</p>
              </div>
            );
          })}
        </div>
        <PostContentCTALayout className="mt-8 sm:mt-8">
          <LeadGenerationButton text="Apply Now" buttonLocation={LEAD_GEN_WHY_CRIO} />
        </PostContentCTALayout>
      </div>
    </section>
  );
};

export default Differentiators;
